import { render, staticRenderFns } from "./GlobalServicesList.vue?vue&type=template&id=7615c7a3&"
import script from "./GlobalServicesList.vue?vue&type=script&lang=js&"
export * from "./GlobalServicesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports